import React from "react";

import { connect } from "react-redux";

import Chip from "./index";

function Entity({ dispatch, config, value, ...props }) {
  const entity = config.find((entity) => entity.id === value);

  return (
    <Chip monospace tooltip={entity && entity.name} value={value} {...props} />
  );
}

const mapStateToProps = (state) => ({
  config: state.prp.config.length ? state.prp.config : state.prp.me.config,
});

export default connect(mapStateToProps)(Entity);
